<template>
  <div>
    <HeaderBreadcrumbs :items="[
      { label: 'Brands', to: '/brands' },
      { label: 'Add New' }
    ]" title="New Brands" />
    <div class="flex-col w-full bg-white shadow-sm rounded-lg px-4 py-4">
      <div class="w-1/2">
        <form @submit.prevent="onSubmit">
          <div class="mb-3">
            <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
              Brand Name
            </label>
            <input id="name" type="text" v-model="form.name" placeholder="Enter Brand Name" :class="[
      'w-full rounded-md px-4 py-2.5 text-sm focus:outline-none focus:ring-2',
      submitted && !form.name ? 'bg-red-300 focus:ring-red-500 placeholder-red-500' : 'border-gray-300 '
    ]" />
    <p v-if="submitted && !form.name" class="text-red-500 text-sm mt-1">Must be filled.</p>

          </div>
          <div class="mb-3 flex justify-between">
            <div class="flex-col w-full">
              <div class="grid grid-cols-2 gap-4 pr-2">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
                    Brand Code
                  </label>
                  <input id="brand_code" type="text" v-model="form.brand_code" placeholder="Enter Brand Code" :class="[
      'w-full rounded-md px-4 py-2.5 text-sm focus:outline-none focus:ring-2',
      submitted && !form.brand_code ? 'bg-red-300 focus:ring-red-500  placeholder-red-500 ' : 'border border-gray-300 '
    ]" />   <p v-if="submitted && !form.brand_code" class="text-red-500 text-sm mt-1">Must be filled.</p>

              

                </div>
                <div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
                      Publisher
                    </label>
                    <multiselect
                    id="vendor"
                    v-model="form.vendor_id"
                    label="name"
                    track-by="name"
                    placeholder="Select Publisher"
                    open-direction="bottom"
                    :options="vendorSearchOptions"
                    :searchable="true"
                    :loading="isVendorSearch"
                    :close-on-select="true"
                    @search-change="getVendorFind"
                    class="custom-multiselect"
                   :class="{ 'error': submitted && !form.vendor_id }"
                  >
                    <template #noResult>
                      <span class="text-sm text-gray-500 px-2 py-1">No publisher found.</span>
                    </template>
                  </multiselect>

                  <p v-if="submitted && !form.vendor_id" class="text-red-500 text-sm mt-1">Must be filled.</p>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-3 flex justify-between">
            <div class="flex-col w-full">
              <div class="grid grid-cols-3 gap-4 pr-0">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
                      Default Contents Type
                  </label>
                  <TypeContent 
                  v-model="form.default_item_type" 
                  :options="defaultItemTypeOption"
                   :isError="contentTypeValidate"
                  :defaultText="'Select Default Contents Type'" />
                  <p v-if="contentTypeValidate" class="text-red-500 text-sm mt-1">Must be filled.</p>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
                      Default Contents Schedule
                  </label>
                  <TypeContent 
                  v-model="form.default_item_schedule" 
                  :options="defaultBrandTypeOption"
                  :defaultText="'Select Default Contents Schedule'"
                  :isError="contentScheduleValidate"
                  />
                  <p v-if="contentScheduleValidate" class="text-red-500 text-sm mt-1">Must be filled.</p>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
                      Release Period
                  </label>
                  <TypeContent 
                  v-model="form.release_period" 
                  :options="defaultReleasePeriodOption"
                  :defaultText="'Select Release Period'"
                  :isError="contentPeriodeValidate"
                  />
                  <p v-if="contentPeriodeValidate" class="text-red-500 text-sm mt-1">Must be filled.</p>
                  </div>
              </div>
            </div>
          </div>
          <div class="mb-3 mr-2">
            <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
              Default Languages
            </label>
            <multiselect 
            placeholder="Select Default Languages" 
            open-direction="bottom" 
            v-model="form.default_languages"
            label="name" track-by="name" 
            :custom-label="nameWithISO" 
            :options="languagesSearchOptions"
            :searchable="true" 
            :close-on-select="true" 
            :options-limit="10" 
              class="custom-multiselect"
            :multiple="true" 
            :class="{ 'error': submitted && !form.default_languages }"
            required>
            <template #noResult>
                      <span class="text-sm text-gray-500 px-2 py-1">No publisher found.</span>
                    </template>
            </multiselect>
            <p v-if="submitted && !form.default_languages" class="text-red-500 text-sm mt-1">Must be filled.</p>
          </div>
          <div class="mb-3 mr-2">
            <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
              Default Countries
            </label>
            <multiselect 
            placeholder="Select Default Countries" 
            open-direction="bottom" 
            v-model="form.default_countries"
            label="iso" 
            track-by="iso" 
            :custom-label="nameWithISO" 
            :options="countriesSearchOptions"
            :loading="isCountriesSearch" 
            :searchable="true"
            class="custom-multiselect"
            :close-on-select="true" 
            :options-limit="10"
            :class="{ 'error': submitted && !form.default_countries }"
            :multiple="true">
                    </multiselect>
                    <p v-if="submitted && !form.default_countries" class="text-red-500 text-sm mt-1">Must be filled.</p>
          </div>
          <div class="mb-3 mr-0">
            <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
              Description (Optional)
            </label>
            <t-textarea type="number" class="rounded-lg mb-4" placeholder="Enter description about brand..."
            v-model="form.description" ></t-textarea>
          </div>
          <div class="mb-3 mr-0">
            <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
              Status
            </label>
            <div>
              <button clas type="button" @click="toggleActive" :class="{
                  'bg-blue-700': form.is_active,
                  'bg-gray-300': !form.is_active
                }" class="w-12 h-6 button-active-inactive rounded-full relative transition-colors duration-200 focus:outline-none">
                              <span :class="{
                  'translate-x-6': form.is_active,
                  'translate-x-0': !form.is_active
                }" class="w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-200"></span>
              </button>
            </div>
          </div>   
          <div class="mb-3 mr-0 flex justify-start">
            <button  type='submit' class="bg-blue-600 text-white px-4 py-2 rounded-lg mr-3">Save</button>
            <button  type="reset" class="bg-whit text-gray-500 border px-4 py-2 rounded-lg">
              <router-link class="text-gray-500 no-underline hover:no-underline hover:text-gray-500" size="sm" :to="{ path: '/brands' }">
               Cancel
            </router-link>
            </button>
          </div>
        </form>
      </div>
    </div>
  
</div>

</template>

<script>


import { mapState, mapActions } from 'vuex';
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import TypeContent from '@/components/form/ContentTypeSelector'
import { CreateBrandPath } from '../../router/clients';
import constant from "../../store/constant";
import {EventBus} from '../../event-bus'

export default {
  name: 'createBrands',
  components: {
    HeaderBreadcrumbs,
    TypeContent,
  },
  data() {
    return {
      CreateBrandPath,
      debounce: null,
      validateInput:false,
      submitted: false,
      id: null,
      form: {
        id: null,
        name: null,
       
        brand_code: null,
        default_item_type: null,
        default_item_schedule: null,
        default_categories: [],
        vendor_id: null,
        release_period: null,
        description: null,
        default_countries: null,
        default_languages: null,
        sort_priority: null,
        is_active: true,
        isCategoriesSearch: false,
        isCountriesSearch: false,
        isVendorSearch: false,
        isPremiumOfferSearch: false,
      },
      contentTypeValidate: false,
      contentScheduleValidate:false,
      contentPeriodeValidate:false,
      defaultItemTypeOption: [
        { value: constant.ITEM_TYPES.MAGAZINE.toLowerCase(), text: "Magazine" },
        { value: constant.ITEM_TYPES.BOOK.toLowerCase(), text: "Book" },
        { value: constant.ITEM_TYPES.NEWSPAPER.toLowerCase(), text: "Newspaper" },
        { value: constant.ITEM_TYPES.AUDIOBOOK.toLowerCase(), text: "Audiobook" },
      ],
      defaultBrandTypeOption: [
        { value: constant.BRAND_TYPE.EDITION, text: "Edition" },
        { value: constant.BRAND_TYPE.MONTHLY, text: "Monthly" },
      ],
      defaultReleasePeriodOption: [
        { value: constant.BRAND_RELEASE_PERIOD.DAILY, text: "Daily" },
        { value: constant.BRAND_RELEASE_PERIOD.WEEKLY, text: "Weekly" },
        { value: constant.BRAND_RELEASE_PERIOD.BIWEEKLY, text: "Bi-Weekly" },
        { value: constant.BRAND_RELEASE_PERIOD.MONTHLY, text: "Monthly" },
        { value: constant.BRAND_RELEASE_PERIOD.BIMONTHLY, text: "Bi-Monthly" },
        { value: constant.BRAND_RELEASE_PERIOD.QUARTERLY, text: "Quaterly" },
        { value: constant.BRAND_RELEASE_PERIOD.SPECIAL, text: "Special" },
      ],
      categoriesSearchOptions: [],
      countriesSearchOptions: [],
      vendorSearchOptions: [],
      languagesSearchOptions: [],
      premiumSearchOptions: [],
    };
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.brands.isLoading,
      isSuccess: (state) => state.brands.isSuccess,
      successMessage: (state) => state.brands.successMessage,
      errorMessage: (state) => state.brands.errorMessage,
    }),
  },
  watch: {
    successMessage: function () {
      if (!this.successMessage) return;
    //  this.messageAlert('success', this.successMessage);
      EventBus.$emit('show-toast', {
            message:'New brands has been added.',
            type: 'success',
          });
      this.$router.push({
        path: `/brands`,
      })
    },
    'form.default_item_type'() {
      this.contentTypeValidate = false
    },
    'form.default_item_schedule'() {
      this.contentScheduleValidate = false
    },
    'form.release_period'() {
      this.contentPeriodeValidate = false
    },
    errorMessage: function () {
      if (!this.errorMessage) return;
      EventBus.$emit('show-toast', {
            message:this.errorMessage,
            type: 'error',
          });
    }
  },
  created() {
    this.setCountriesOptions();
    this.setVendorOptions();
    this.setCountriesOptions()
    this.languagesSearchOptions = Object.entries(constant.LANGUAGE_CHOICES).map((item) => {
      return {
        iso: item[0].toUpperCase(),
        name: item[0]
      }
    });
  },
  mounted() {
    this.setCountriesOptions();
    this.setVendorOptions();
    this.setCountriesOptions()
    this.languagesSearchOptions = Object.entries(constant.LANGUAGE_CHOICES).map((item) => {
      return {
        iso: item[0].toUpperCase(),
        name: item[0]
      }
    });
  },
  methods: {
    ...mapActions("brands", ["createBrands", "getVendor", "searchCategories", "getCountries"]),
    ...mapActions('vendors', ['searchVendors']),
    onSubmit(event) {
      event.preventDefault();
      this.submitted = true;
    
      const isContentInvalid = this.form.default_item_type === null 
      || this.form.default_item_schedule === null 
      || this.form.release_period === null
      || this.form.name === null
      || this.form.brand_code === null
      
      if (isContentInvalid) {
        this.contentTypeValidate = true;
        this.contentScheduleValidate = true;
        this.contentPeriodeValidate = true
        this.validateInput = true
      }

 
      if (!this.form.vendor_id || 
      !this.form.default_languages ||
      !this.form.default_countries ) return; 
      const data = this.form;
     
      const payload = {
        name: data.name,
        brand_code: data.brand_code,
        vendor_id: data.vendor_id.id,
        default_item_type: data.default_item_type,
        default_item_schedule: data.default_item_schedule,
        release_period: data.release_period,
        description: data.description,
        default_languages: data.default_languages.map(item => item.iso.toLowerCase()),
        default_countries: data.default_countries.map(item => item.iso.toLowerCase()),
        is_active: data.is_active,
      }
      console.log('payload', payload)
    
         this.createBrands(payload);
    },
    setCountriesOptions() {
      this.isCountriesSearch = true;
      this.getCountries().then((response) => {
        this.countriesSearchOptions = response.data.data.rows;
        this.isCountriesSearch = false;
      }).catch(() => {
        this.isCountriesSearch = false;
      });
    }, 
    setVendorOptions() {
      this.isVendorSearch = true;
      this.getVendor()
        .then((response) => {
          this.vendorSearchOptions = response.data.data.rows;
          this.isVendorSearch = false;
        })
        .catch(() => {
          this.isVendorSearch = false;
        });
    },
    toggleActive() {
      this.form.is_active = !this.form.is_active;
    },
    getVendorFind(query) {
        this.searchVendors({ q: query }).then((response) => {
          this.vendorSearchOptions = response.data.data.rows;
         
        }).catch(() => {
        });
      
    }, nameWithISO({ name, iso }) {
      return `${iso} - ${name}`
    }, reset() {
      Object.assign(this.$data, this.$options.data.call(this));
    },
  }
};

</script>
<style>
.button-active-inactive {
  position: relative;
  display: inline-flex;
  align-items: center;
}
</style>